
import { Suspense } from "react";
import type React from "react";
import { getEditor, type EditorProps } from "@/modules/_registry.client";

export function ModuleEditorHost(props: EditorProps & { fallback: React.ReactNode }) {
  const Editor = getEditor(props.rule.kind);
  if (!Editor) return <>{props.fallback}</>;
  const { fallback, ...rest } = props;
  return (
    <Suspense fallback={null}>
      <Editor {...rest} />
    </Suspense>
  );
}
